// To be removed
import React, { useState, useEffect, useContext } from "react";
import _ from "lodash";

import styles from "./FiveYearVision.module.scss";
import { useQuery } from "@apollo/client";
import gql from "graphql-tag";
import { FetchContext } from "../../context/fetchContext";
import { useAuth } from "../../context/authContext";
import { useDepartmentFilter } from "../../context/departmentFilterContext";

import { isAuthed } from "../../utils/authorization";

import { Container, Grid, Typography, Divider, Hidden, Button } from "@material-ui/core";

import Icon from "@mdi/react";
import { mdiCalendarAlert, mdiCalendarStar } from "@mdi/js";
import Loading from "../../components/Loading/Loading";
import NotesButton from "../../components/Notes/NotesButton";

import EditDialog from "./EditDialog";
import { bhagTimeRemaining, formatAs } from "../../utils/dates";

const FiveYearVision = ({ params, org }) => {
  const { fetch } = useContext(FetchContext);
  const { auth } = useAuth();
  const { departmentFilter } = useDepartmentFilter();
  const [dialog, setDialog] = useState({ org: null, core: null, bhag: null });
  const [initForm, setInitForm] = useState({});

  const handleEditBhag = () => {
    setInitForm({ goal: bhag.goal, targetDate: parseInt(bhag.targetDate) });
    setDialog({ ...dialog, bhag: true });
  };

  const handleEditClose = () => {
    setDialog({ org: null, core: null, bhag: null });
  };

  const { bhag, notes } = org;

  return (
    <>
      <Container maxWidth={false}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={2}>
                <Typography variant="h5" className={styles.label}>
                  BHAG<sup>&#174;</sup>
                </Typography>
              </Grid>
              <Grid item xs={12} sm={10}>
                <Typography variant="h6" className={styles.label}>
                  Big Hairy Audacious Goal
                </Typography>
                <div className={styles.flexParagraph}>
                  <Typography variant="h5" gutterBottom>
                    {bhag.goal}
                  </Typography>
                  {bhag.goal ? (
                    <>
                      <NotesButton id={params.org} core="bhag" model="organization" size={1.25} doc={{ notes: notes["bhag"] }} />
                      {isAuthed(auth, "company admin") && (
                        <Button onClick={handleEditBhag} variant="outlined" className={styles.editButton}>
                          Edit
                        </Button>
                      )}
                    </>
                  ) : (
                    <Button onClick={handleEditBhag} color="primary" disabled={!isAuthed(auth, "company admin")}>
                      Create BHAG <sup>&#174;</sup>
                    </Button>
                  )}
                </div>

                <Typography variant="h6" className={styles.label}>
                  Target Date
                </Typography>
                <div className={styles.flexParagraph}>
                  <Icon path={mdiCalendarStar} size={1.5} color="rgba(0, 0, 0, 0.65)" className={styles.icon} />
                  <Typography variant="h5">{formatAs(bhag.targetDate, "MMM d, y")}</Typography>
                </div>

                <Typography variant="h6" className={styles.label}>
                  Time Remaining
                </Typography>
                <div className={styles.flexParagraph}>
                  <Icon path={mdiCalendarAlert} size={1.5} color="rgba(0, 0, 0, 0.65)" className={styles.icon} />
                  <Typography variant="h5">{bhagTimeRemaining(bhag.targetDate)}</Typography>
                </div>
                <Divider className={styles.divider} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>

      <EditDialog id={params.org} open={dialog} handleClose={handleEditClose} initForm={initForm} />
    </>
  );
};

export default FiveYearVision;
